<template>
  <div class="page px-3" v-if="visible">
    <div>
      <h4 class="function-title">Empresas Asociadas</h4>
    </div>
    <b-row>
      <b-col sm="8" offset-sm="2">
        <b-row>
          <b-col class="text-left" sm="6">
            <b-btn variant="primary" @click="agregarEmpresaAsociada">
              <i class="fas fa-plus"></i> Agregar Empresa
            </b-btn>
          </b-col>
          <b-col class="text-right" sm="6">
            <b-btn variant="danger" @click="cerrarEmpresasAsociadas">
              <i class="fas fa-times"></i> Cerrar
            </b-btn>
          </b-col>
        </b-row><br>
        <b-row>
          <b-col sm="12" v-if="empresas.length > 0">
            <label for=""><b>Empresas vigentes en Póliza</b></label>
            <b-table style="table-layout: fixed"
              :items="empresasVigentes"
              :fields="camposEmpresasVigentes"
              sort-by="cuota"
              bordered>
            </b-table>
            <label for=""><b>Empresas asociadas al productor</b></label>
            <b-table style="table-layout: fixed"
              :items="empresas.filter(x => x.id > 0)"
              :fields="camposEmpresas"
              sort-by="cuota"
              bordered>

              <template #cell(acciones)="row">
                <b-button v-if="row.item.id > 0" size="sm" @click="borrarEmpresaParaPoliza(row.item)" class="mr-2">
                  <i class="fas fa-trash-alt"></i>Quitar
                </b-button>
              </template>

            </b-table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- Este modal de empresas asociadas -->
    <b-modal v-model="show"  ref="modal" :title="empresasAsociadasTitulo">
      <b-row>
        <b-col sm="12">
          <b-form-group label="Razón Social">
            <b-form-input
              type="text"
              v-model="form.razonSocial"
              @blur="$v.form.razonSocial.$touch"
              :state="$v.form.razonSocial.$dirty ? !$v.form.razonSocial.$error : null"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group label="CUIT">
            <b-form-input
              type="text"
              min="11"
              max="11"
              v-model="form.cuit"
              v-mask="'##-########-#'"
              @blur="$v.form.cuit.$touch"
              :state="$v.form.cuit.$dirty ? !$v.form.cuit.$error : null"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group label="Dirección">
            <b-form-textarea
              type="text"
              v-model="form.direccion"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <template #modal-footer="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="success" @click="submit" :disabled="$v.form.$invalid">
          {{ botonSubmit }}
        </b-button>
        <b-button size="sm" variant="danger" @click="cancel()">
          Salir
        </b-button>
      </template>

    </b-modal>

  </div>
</template>

<script>
import { required, minLength, maxLength, numeric } from 'vuelidate/lib/validators';

export default {
  props: {
    nroPoliza: {
      type: Number | String
    },
    nroEndoso: {
      type: Number | String
    },
    estadoCNR: ''
  },

  data() {
    return {
      visible: false,
      nuevaEmpresa: false,
      empresas: [],
      empresasVigentes: [],
      camposEmpresasVigentes: [
        {
          key: 'razon_social',
          label: 'Razón Social',
          class: 'text-center'
        },
        {
          key: 'cuit',
          label: 'CUIT',
          class: 'text-center'
        },
        {
          key: 'direccion',
          label: 'Dirección',
          class: 'text-center'
        },],
      camposEmpresas: [
        {
          key: 'razon_social',
          label: 'Razón Social',
          class: 'text-center'
        },
        {
          key: 'cuit',
          label: 'CUIT',
          class: 'text-center'
        },
        {
          key: 'direccion',
          label: 'Dirección',
          class: 'text-center'
        },
        {
          key: 'acciones',
          label: 'Acciónes',
          class: 'text-center'
        }
      ],
      show: false,
      empresasAsociadasTitulo: '',
      botonSubmit: '',
      form: {}
    };
  },
  validations: {
    form: {
      razonSocial: { required },
      cuit: { required,
              minLength: minLength(13),
              maxLength: maxLength(13)
            },
    }
  },
  methods: {
    identificadorUsuario(){
      if (this.$store.state.auth.cod_agente && this.$store.state.auth.cod_agente != '')
        return this.$store.state.auth.cod_agente;
      else 
        return this.$store.state.auth.email;
    },
    cerrarEmpresasAsociadas(){
      this.$emit('cerrar', true)
    },
    agregarEmpresaAsociada(){
      this.empresasAsociadasTitulo = 'Asociar nueva empresa a mi productor'
      this.form = {}
      this.nuevaEmpresa = true
      this.botonSubmit = 'Asociar'
      this.show = true
    },
    borrarEmpresaParaPoliza(empresa) {
      if (confirm('¿Esta seguro de eliminar su asociación con esta empresa?')) {
        const payload = {
          idEmpresa: empresa.id,
          productor: this.identificadorUsuario()
          // poliza: this.nroPoliza
        };
        return this.$api.post(`clasula-no-repeticion/empresas-asociadas/eliminar`, payload).then(() => {
          let empresasNuevo = this.empresas.filter(e => e.id != empresa.id)
          this.empresas = empresasNuevo
          this.$emit('limpiar', true)
          this.$toast.success('Se ha eliminado correctamente su asociación con esta empresa')
        }).catch((err) => {
          this.$toast.error('Ocurrió un error al enviar la solicitud para desasociarse de esta empresa.');
          //console.log(err.response);
        });
      }
    },
    submit() {      
      this.$v.form.$touch();

      if (this.$v.form.$invalid) {
        return null
      }

      let empresaYaAsociada = this.empresas.filter(e => e.cuit == this.form.cuit)
      if (empresaYaAsociada.length > 0 && this.nuevaEmpresa) {
        this.$toast.error('¡Error! ¡El cuit ingresado ya pertenece a una empresa asociada!')
        return null
      }

      const payload = {
        nombre: this.form.razonSocial,
        cuit: this.form.cuit,
        direccion: this.form.direccion ? this.form.direccion : '-',
        productor: this.identificadorUsuario()
        // poliza: this.nroPoliza
      };
      //console.log("se ve esto en cod_agente"+this.$store.state.auth.cod_agente);
      
      return this.$api.post(`clasula-no-repeticion/empresas-asociadas/asociar`, payload).then(res => {
        // res.data.nro_poliza = this.nroPoliza
        this.empresas.push(res.data)
        this.show = false
        this.$toast.success('Se ha asociado correctamente una nueva empresa.')
      }).catch((err) => {
        this.show = false
        this.$toast.error('Ocurrió un error al enviar la solicitud para asociar la empresa.');
        //console.log(err.response);
      });
    },
  },
  watch: {
    visible(val) {      
      if (val) {
        const agente = this.identificadorUsuario();
        const loading = this.$loading.show();
        this.$api(`clasula-no-repeticion/empresas-asociadas-by-agent/${agente}`).then(res => {
          let asociadasByAgent = res.data;
          this.$api(`clasula-no-repeticion/empresas-asociadas/${this.nroPoliza}/${this.nroEndoso}`).then(res => {
            loading.hide();
            //console.log(res.data);
            this.empresas = asociadasByAgent.concat(res.data);
            this.empresasVigentes = this.empresas.filter(x => x.id == -1);
          });
        });
      }
    }
  }
};
</script>
